import { render, staticRenderFns } from "./Part1.vue?vue&type=template&id=197117d2&scoped=true"
var script = {}
import style0 from "./Part1.vue?vue&type=style&index=0&id=197117d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197117d2",
  null
  
)

export default component.exports